import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { PermissionsService } from '../services/permissions.service';

@Component({
  selector: 'app-donation-pass-scans-list',
  templateUrl: './donation-pass-scans-list.component.html',
  styleUrls: ['./donation-pass-scans-list.component.scss']
})
export class DonationPassScansListComponent implements OnInit {
public scanList: any;
public scanData: any = [];
  public from_date = moment(new Date()).format('YYYY-MM-DD');
  public to_date = moment(new Date()).format('YYYY-MM-DD');
  public perPage = 25;
  public totalCount = 0;
  public page = 1;
  public maxDate =  '';
  showPreviewModal = false;

  constructor(
    private apiService: ApiService,
    private appComponet: AppComponent,
    public permissionsService: PermissionsService,
    private appComponent: AppComponent, 
    ) { }

  ngOnInit() {
    this.getList('');
  }

  getList(_type) {
    this.appComponet.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    this.apiService.getDataFromServer(`/admin/donation_pass_scans?&page=${this.page}&perpage=${this.perPage}`).subscribe(
      (res: any) => {
        this.appComponet.hideLoader();
        this.scanList = res;
        this.scanList.data.map(res => {
          res.date = moment.utc(res.date).local().format('DD-MM-yyyy');
        });
        this.totalCount = res.total;
      },
      err => {
        this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
        this.appComponet.hideLoader();
        console.log(err);
      }
    );
  }

  openInfoModal(data) {
    this.showPreviewModal = true;
    this.scanData = data.scans;
  }

  CloseInfoModal() {
    this.showPreviewModal = false;
  }

}
